import { card } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const activateCard = gql`
mutation ActivateCard($token: IdempotencyToken!, $input: ActivateCardInput!) {
    activateCard(idempotencyId: $token, input: $input) {
        ... on ActivateCardSuccess {
            card {
                ...card
            }
            title
            message
           __typename

        }
        ... on ActivateCardTooManyAttempts {
            title
            message
           __typename
        }
        ... on ActivateCardNotFound {
            title
            message
            __typename

        }
        ... on ActivateCardError {
            title
            message
           __typename

        }
  }
  ${card}
}`;
export default activateCard;
